import { RequestRelatorioConsultaPagamentoDTO, RequestConsultaPagamentoFiltroDTO } from './gerencial/RequestRelatorioConsultaPagamentoDTO';
import { RequestRelatorioDiretivoDTO } from './gerencial/RequestRelatorioDiretivoDTO';
import { AxiosRequestConfig } from "axios";
import { integracaoRelatoriosGerenciaisApiConfig } from "./config";
import { RelatorioServicosVeicularesModel } from '@/models/administracao/servicos-veiculares/RelatorioServicosVeicularesModel';
import Api from "./Api";
import { RelatorioServicosSaudeModel } from "@/models/administracao/servicos-saude/RelatorioServicosSaudeModel";

export class RelatoriosGerenciaisApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  gerarRelatorioConsultaPagamento(
    tipo: string,
    requestDTO: RequestRelatorioConsultaPagamentoDTO
  ): Promise<any> {
    return this.get(
      tipo.toLocaleLowerCase() === 'pdf' ? "/relatorio/relatorio-pagamento/pdf" : '/relatorio/relatorio-pagamento/xls',
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
        params: requestDTO
      }
    );
  }

  gerarConsultaPagamento(
    requestDTO: RequestConsultaPagamentoFiltroDTO
  ): Promise<any> {
    return this.get(
      "/relatorio/relatorio-pagamento",
      { params: requestDTO }
    )
    .then((res) => {
      const { data } = res;
      return data;
    })
    .catch((err) => {
      throw err;
    });
  }

  gerarRelatorioDiretivo(
    requestDTO: RequestRelatorioDiretivoDTO, tipo: string
  ): Promise<any> {
    return this.get(
      tipo.toLocaleLowerCase() === 'pdf' ? "/relatorio/relatorio-pagamento/pdf" : '/relatorio/relatorio-pagamento/xls',
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
        params: requestDTO
      }
    );
  }
}

export const integracaoRelatoriosGerenciaisApi = new RelatoriosGerenciaisApi(
  integracaoRelatoriosGerenciaisApiConfig
);